<h2>About Me</h2>

<p>This information is optional and used only to calculate your personal inhaled dose.</p>

<form class="usa-form">
  <fieldset class="usa-fieldset">
    <legend class="usa-legend">Sex</legend>
    <usa-radio-group [name]="'sex'" [value]="sex" [(ngModel)]="sex">
      <usa-radio [value]="'1'">Male</usa-radio>
      <usa-radio [value]="'2'">Female</usa-radio>
    </usa-radio-group>
  </fieldset>

  <label class="usa-label" for="input-age">Age</label>
  <input class="usa-input usa-input--small" id="input-age" name="input-age" type="number" min="1" max="100" step="1" [(ngModel)]="userCharacteristics.age">
  
  <label class="usa-label" for="input-weight">Body weight (kg)</label>
  <input class="usa-input usa-input--small" id="input-weight" name="input-weight" type="number" [(ngModel)]="userCharacteristics.weight">
  
  <label class="usa-label" for="input-height">Height (cm)</label>
  <input class="usa-input usa-input--small" id="input-height" name="input-height" type="number" [(ngModel)]="userCharacteristics.height">
</form>

<p>
  <button class="usa-button" type="button" (click)="save()">Save</button>
  <button class="usa-button usa-button--secondary" type="button" routerLink="/" skipLocationChange>Cancel</button>
</p>
